var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import MarkdownViewer from "../../Markdown";
import React, { Component } from 'react';
import { TabContent, TabLink, Tabs } from 'react-tabs-redux';
import { Translate } from "../../I18N";








export class MarkDown extends Component {
  render() {
    const { rows = 6, value = '', onChange, showPreview = true } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "markdownEditor" }, void 0, /*#__PURE__*/
      _jsx(Tabs, { renderActiveTabContentOnly: true }, void 0, /*#__PURE__*/
      _jsx("div", { className: "tab-nav" }, void 0, /*#__PURE__*/
      _jsx(TabLink, { to: "edit", default: true, component: "div" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Edit")),

      showPreview && /*#__PURE__*/
      _jsx(TabLink, { to: "preview", component: "div" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Preview")), /*#__PURE__*/


      _jsx("a", {
        className: "tab-link tab-link--help",
        href: "https://guides.github.com/features/mastering-markdown/",
        target: "_blank",
        rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "help"))), /*#__PURE__*/


      _jsx(TabContent, { for: "edit" }, void 0, /*#__PURE__*/
      _jsx("textarea", { className: "form-control", rows: rows, onChange: onChange, value: value })),

      showPreview && /*#__PURE__*/
      _jsx(TabContent, { for: "preview", className: "markdownViewer" }, void 0, /*#__PURE__*/
      _jsx(MarkdownViewer, { html: this.props.htmlOnViewer, markdown: value })))));





  }
}